import styled from 'styled-components'

export const Container = styled.div`
  .react-datepicker {
    font-family: ${({ theme }) => theme.fontFamily} !important;
    font-weight: 400;
    border: none;
    border-radius: 12px;
    background: var(--Persistent-White, #fff);

    /* Overlay */
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05), 0px 15px 25px 0px rgba(0, 0, 0, 0.07);

    .react-datepicker__header {
      background: var(--Persistent-White, #fff);
      border: none;
    }

    .react-datepicker__day--selected {
      color: var(--Text-Primary, #14171f);
    }

    .react-datepicker__day-name {
      text-transform: capitalize;
      color: var(--Text-Secondary, #4d5874);
    }

    .react-datepicker__day--selected {
      background-color: ${({ theme }) => theme.colors.primary};
      color: white;
    }

    .react-datepicker__day--disabled {
      color: var(--Text-Tertiary, #8893a8);
    }

    .react-datepicker__day--keyboard-selected {
      background-color: white;
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 16px 16px 8px 16px;
  box-sizing: border-box;
`

export const HeaderTitle = styled.div`
  flex: 1;

  text-align: left;
  color: var(--Text-Primary, #14171f);

  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */

  text-transform: capitalize;
`

export const ButtonArrowContainer = styled.button`
  border: none;
  outline: none;
  background-color: white;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  :hover {
    background: ${({ disabled }) => (disabled ? 'white' : 'var(--background-neutral, #dfe2ea)')};
  }

  height: 28px;
  width: 28px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 6px;
  border: 1px solid var(--Border-Neutral, #bbc1d3);
`
